import React, { useState, useRef, useEffect } from 'react';
import { I } from '../common/v5/config';

const AgentAvatarInput = ({ currentAvatar, onAvatarChange, onAvatarRemove }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [hasValidImage, setHasValidImage] = useState(false);
  const fileInputRef = useRef(null);

  // Check if we have a valid image to display
  useEffect(() => {
    const imageToShow = previewUrl || currentAvatar;
    // Ensure imageToShow is a string before calling trim()
    const isValidImage = Boolean(imageToShow && typeof imageToShow === 'string' && imageToShow.trim() !== '');
    setHasValidImage(isValidImage);
  }, [previewUrl, currentAvatar]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      onAvatarChange(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Clear local state first
    setPreviewUrl(null);
    setHasValidImage(false);
    
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    
    // Call parent handler
    if (onAvatarRemove) {
      onAvatarRemove();
    }
  };

  const handleImageError = () => {
    setHasValidImage(false);
  };

  const displayUrl = previewUrl || currentAvatar;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '20px' }}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/jpeg,image/png,image/gif"
        style={{ display: 'none' }}
      />
      
      {hasValidImage ? (
        // Show avatar with remove button
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <img 
            src={displayUrl} 
            alt="Agent Avatar"
            onError={handleImageError}
            style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '3px solid #e1e5e9',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              display: 'block'
            }}
          />
          <button 
            type="button" 
            onClick={handleRemove}
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
              zIndex: 10,
              lineHeight: '1'
            }}
            title="Remove avatar"
          >
            ×
          </button>
        </div>
      ) : (
        // Show upload area when no avatar
        <div 
          onClick={handleUploadClick}
          style={{
            width: '120px',
            height: '120px',
            border: '2px dashed #ccc',
            borderRadius: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backgroundColor: '#f9f9fa',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#007bff';
            e.currentTarget.style.backgroundColor = '#f0f8ff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#ccc';
            e.currentTarget.style.backgroundColor = '#f9f9f9';
          }}
        >
          <div style={{ 
            fontSize: '32px', 
            color: '#999', 
            marginBottom: '8px',
            lineHeight: '1'
          }}>
            +
          </div>
          <div style={{ 
            fontSize: '12px', 
            color: '#666',
            textAlign: 'center'
          }}>
            {I('Choose a file')}
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentAvatarInput; 